var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect10, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacturacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECECEC"
    },
    d: "M376,448H72V40C72,22.328,57.672,8,40,8h-8h312c17.672,0,32,14.328,32,32V448z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA82F"
    },
    d: "M72,448h336c17.672,0,32-14.328,32-32v-32H136v32c0,17.672-14.328,32-32,32H72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA82F"
    },
    d: "M72,104H8V40C8,22.328,22.328,8,40,8l0,0c17.672,0,32,14.328,32,32V104z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C1CE"
    },
    d: "M376,155.672c-32.456,10.192-56,40.504-56,76.328c0,35.816,23.544,66.128,56,76.328V155.672z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEA82F"
    },
    cx: 408,
    cy: 208,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8031"
    },
    d: "M408,272c-41.48,0-75.584-31.576-79.6-72c-0.256,2.632-0.4,5.296-0.4,8c0,44.184,35.816,80,80,80 s80-35.816,80-80c0-2.704-0.144-5.368-0.4-8C483.584,240.424,449.48,272,408,272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 424,
    style: {
      fill: "#92E0C0"
    },
    width: 96,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 40,
    style: {
      fill: "#92E0C0"
    },
    width: 224,
    height: 88
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 80,
    style: {
      fill: "#FF8031"
    },
    width: 64,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 464,
    style: {
      fill: "#48C397"
    },
    width: 96,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A6"
    },
    d: "M40,424l-7.752-62.024c-0.168-1.312-0.248-2.64-0.248-3.968v-68.016c0-1.328,0.08-2.656,0.248-3.968 l6.664-53.288c0.712-5.712,2.96-11.128,6.496-13.896L91.16,160c3.056-5.704,7.752-8,12.72-8l0,0c8.904,0,16.12,7.216,16.12,16.12 v2.72c0,3.36-1.048,6.632-3,9.368l-31.04,43.456c-3.88,5.416-5.96,11.92-5.96,18.592v46.192c0,4.968,1.16,9.864,3.376,14.312L96,328 l0,0l35.032-35.032c3.184-3.184,7.496-4.968,12-4.968l0,0C152.4,288,160,295.6,160,304.968l0,0c0,4.504-1.784,8.816-4.968,12L96,376 v48H40z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104,136h240V32H104V136z M120,48h208v72H120V48z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 248,
    width: 160,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 184,
    width: 48,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 184,
    width: 48,
    height: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 216,
    width: 48,
    height: 16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 216,
    width: 48,
    height: 16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 312,
    width: 128,
    height: 16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 344,
    width: 48,
    height: 16
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 344,
    width: 48,
    height: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408,184c4.416,0,8,3.592,8,8h16c0-10.416-6.712-19.216-16-22.528V152h-16v17.472c-9.288,3.312-16,12.112-16,22.528 c0,13.232,10.768,24,24,24c4.416,0,8,3.592,8,8s-3.584,8-8,8s-8-3.592-8-8h-16c0,10.416,6.712,19.216,16,22.528V264h16v-17.472 c9.288-3.312,16-12.112,16-22.528c0-13.232-10.768-24-24-24c-4.416,0-8-3.592-8-8S403.584,184,408,184z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 200,
    width: 16,
    height: 16
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 200,
    width: 16,
    height: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.608,256.248C491.024,241.904,496,225.216,496,208c0-48.52-39.48-88-88-88c-8.328,0-16.36,1.24-24,3.408V40 c0-22.056-17.944-40-40-40H40C17.944,0,0,17.944,0,40v72h64v59.608l-32.4,41.648c-4.528,4.016-7.648,10.672-8.632,18.48 l-6.656,53.296c-0.2,1.648-0.312,3.304-0.312,4.96v68.016c0,1.664,0.112,3.312,0.312,4.96L22.936,416H0v80h112v-40h296 c22.056,0,40-17.944,40-40v-40h-64v-83.408c7.64,2.168,15.672,3.408,24,3.408c23.56,0,45.696-9.184,62.32-25.872l-11.328-11.296 C445.384,272.488,427.272,280,408,280c-39.704,0-72-32.304-72-72s32.296-72,72-72s72,32.304,72,72 c0,14.088-4.072,27.736-11.768,39.464L481.608,256.248z M16,96V40c0-13.232,10.768-24,24-24s24,10.768,24,24v56H16z M32.184,360.992 C32.064,360,32,359,32,358.008v-68.016c0-0.992,0.064-1.992,0.184-2.976l6.656-53.288c0.56-4.472,2.2-7.592,3.496-8.6l47.144-60.216 l0.744-1.144c1.784-3.336,3.96-3.768,5.656-3.768c4.48,0,8.12,3.64,8.12,8.12v2.72c0,1.704-0.52,3.336-1.504,4.72l-31.04,43.456 c-4.88,6.816-7.456,14.856-7.456,23.24v46.192c0,6.168,1.464,12.36,4.216,17.888L75.056,320H72v16h19.312l37.376-37.376 c1.672-1.664,3.984-2.624,6.344-2.624c4.944,0,8.968,4.024,8.968,8.968c0,2.4-0.928,4.648-2.624,6.344L80,372.688V416H39.064 L32.184,360.992z M96,480H16v-48h80V480z M432,416c0,13.232-10.768,24-24,24H135.984c5.032-6.688,8.016-15,8.016-24v-24h288V416z  M320,208c0,34.112,19.552,63.688,48,78.288V376H128v40c0,10.416-6.712,19.216-16,22.528V416H96v-36.688l56.688-56.688 c4.72-4.712,7.312-10.984,7.312-17.656C160,291.2,148.8,280,135.032,280c-6.576,0-13.008,2.664-17.656,7.312l-27.184,27.184 l-7.664-15.312c-1.656-3.32-2.528-7.032-2.528-10.736v-46.192c0-5.032,1.544-9.848,4.472-13.952l31.04-43.456 c2.936-4.104,4.488-8.952,4.488-14.016v-2.72C120,154.824,109.176,144,95.88,144c-6.208,0-11.736,2.44-15.88,6.832V40 c0-9.04-3.128-17.296-8.208-24H344c13.232,0,24,10.768,24,24v89.712C339.552,144.312,320,173.888,320,208z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacturacion);
export default __webpack_public_path__ + "static/media/facturacion.96ab4abae78dec2575df236d0ed8919d.svg";
export { ForwardRef as ReactComponent };